import { useState } from 'react';
import {TopicsList} from "../../../data/TopicsList";
import {LoadingLayer} from "../../LoadingLayer";
import {useNavigate} from "react-router-dom";

export const submitCreateProfile = async (profile) => {
    try {
        const response = await fetch(
            'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/profiles',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'user-token': localStorage.getItem('id_token'),
                },
                body: JSON.stringify(profile),
            },
        );
        const data = await response.json();
        console.log(data);
    } catch (error) {
        console.error('Error:', error);
    }
};

export const CreateProfile = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
  const [form, setForm] = useState({
    name: '',
    institution: '',
    country: '',
    state: '',
    grade: '',
    category: TopicsList[0].name,
    suggestedArea: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const createProfile = (profile) => {
      let profileObject = {
          "name": profile.name,
          "institution": profile.institution,
          "country": profile.country,
          "state": profile.state,
          "grade": profile.grade,
          "category": profile.category,
          "suggestedArea": profile.suggestedArea,
      };
      setLoadingMessage('Creating profile...');
      setIsLoading(true);
      submitCreateProfile(profileObject).then(() => {
          setIsLoading(false);
          navigate('/home');
      });
  }

  return (
    <div className="snn-user-home-main-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />
      <div className="snn-user-home-main-content">
        <h1>Create Profile</h1>
        <form className="snn-panel-form-wrapper" onSubmit={(e) => { e.preventDefault(); createProfile(form); }}>
          <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required />
          <input name="institution" placeholder="Institution" value={form.institution} onChange={handleChange} required />
          <input name="country" placeholder="Country" value={form.country} onChange={handleChange} required />
          <input name="state" placeholder="State" value={form.state} onChange={handleChange} required />
          <input name="grade" placeholder="Grade" value={form.grade} onChange={handleChange} required />
            <select id="topic_id" name="category" onChange={handleChange}>
                {TopicsList.map((topic) => {
                    return (
                        <option value={topic.name} key={topic.id} id="topic_id" name="topic_id">
                            {topic.name}
                        </option>
                    );
                })}
            </select>
            <input name="suggestedArea" placeholder="Suggested Area" value={form.suggestedArea} onChange={handleChange}
                   required/>
            <button type="submit">Create Profile</button>
        </form>
      </div>
    </div>
  );
};
